import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OrderService {
  constructor() {}

  private isAddressStepValid = new BehaviorSubject<boolean>(false);
  private isPaymentStepValid = new BehaviorSubject<boolean>(false);
  private isCheckedOutSuccessfully = new BehaviorSubject<boolean>(false);

  isAddressStepValid$ = this.isAddressStepValid.asObservable();
  isPaymentStepValid$ = this.isPaymentStepValid.asObservable();
  isCheckedOutSuccessfully$ = this.isCheckedOutSuccessfully.asObservable();

  syncAddressStepValidation(isValid: boolean): void {
    this.isAddressStepValid.next(isValid);
  }
  syncPaymentStepValidation(isValid: boolean): void {
    this.isPaymentStepValid.next(isValid);
  }

  orderCheckedOut(): void {
    this.isCheckedOutSuccessfully.next(true);
  }

  orderCheckedOutReset(): void {
    this.isCheckedOutSuccessfully.next(false);
  }
}
